<mcg-window #mapWindow [title]="translate('Visualizador_wms')">
  <div>
    <input id="url-wms" type="text" placeholder="URL del WMS" [(ngModel)]="userWmsUrl">
    <button (click)="fetchCapabilities()">Obtener capas</button>
  </div>
  <div *ngIf="capabilities && capabilities.length > 0">
    <label for="layerSelect">Selecciona una capa:</label>
    <select id="layerSelect" [(ngModel)]="selectedLayer">
      <option *ngFor="let layer of capabilities" [value]="layer.name">
        {{ layer.title }} ({{ layer.name }})
      </option>
    </select>
    <button (click)="updateWmsLayer()">Mostrar capa en el mapa</button>
  </div>
  <div #mapContainer id="map"></div>
</mcg-window>
